export const isClickOutsideRect = (el: Element) => (ev: MouseEvent) => {
  const { top, left, right, bottom } = el.getBoundingClientRect();
  const { clientX, clientY } = ev as MouseEvent;
  const INSIDE_X = clientX > left && clientX < right;
  const INSIDE_Y = clientY > top && clientY < bottom;
  return !(INSIDE_X && INSIDE_Y);
};

export const onTouchOutsideOnce = (cb: () => void, closeAnyWay = false) => (
  el: () => Element,
  ignoreElms: () => Element[] = () => []
): (() => void) => {
  let unsubscribe = () => {
    /*  */
  };
  const listener = (ev: Event) => {
    unsubscribe = () => {
      window.removeEventListener("click", listener, true);
    };
    const els = ignoreElms().filter((f) => f);
    let ignore = false;
    for (const ignoreEl of els) {
      ignore = !isClickOutsideRect(ignoreEl)(ev as MouseEvent);
    }
    const theEl = el();
    console.log("theEl: ", theEl);
    if (!theEl) {
      unsubscribe();
      return;
    }
    const isOutside = isClickOutsideRect(el())(ev as MouseEvent);
    console.log("isOutside: ", isOutside);
    if (ignore && isOutside) {
      unsubscribe();
      // the click was inside an area that
      // should be ignored by the callback
      return;
    } else {
      //  ev.stopImmediatePropagation();
      //  ev.stopPropagation();
    }
    if (closeAnyWay) {
      cb();
      unsubscribe();
      return;
    }
    if (isOutside) {
      cb();
      unsubscribe();
    }
  };
  window.addEventListener("click", listener, true);
  return unsubscribe;
};

export const onKey = (keyStr: string, capture = true) => (
  cb: (ev: KeyboardEvent) => void
) => {
  const listener = (ev: KeyboardEvent) => {
    const { key, code } = ev;
    if (keyStr === key) {
      cb(ev);
    }
  };
  document.addEventListener("keydown", listener, capture);
  return () => document.removeEventListener("keydown", listener, capture);
};
